import {
  CommonRawEventName,
  type TrackedLoadedPageName,
  useEmitCoreCommonEventBeforeLoad,
} from "@b2bportal/core-tracking";
import {
  Page as CorePage,
  type PageComponentProps,
} from "@b2bportal/core-ui/overridable";
import { PageHeader } from "@tenant/ui";

type PageProps = {
  shouldDisplayLogInPrompt?: boolean;
  shouldDisplayLogInButton?: boolean;
  fullWidth?: boolean;
  trackingName?: TrackedLoadedPageName;
  showNavigation?: boolean;
} & PageComponentProps;

export const Page = ({
  fullWidth,
  shouldDisplayLogInPrompt,
  shouldDisplayLogInButton,
  trackingName,
  showNavigation = false,
  ...rest
}: PageProps) => {
  useEmitCoreCommonEventBeforeLoad(
    {
      name: CommonRawEventName.PageOpened,
      properties: {
        page: trackingName,
      },
    },
    trackingName != null
  );

  return <CorePage header={<PageHeader fullWidth={fullWidth} />} {...rest} />;
};
